import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Command } from "@air/cmdk";
import { Search as SearchIcon } from "@air/next-icons";
import { tailwindMerge } from "@air/tailwind-variants";
import classNames from "classnames";
import { memo } from "react";
import { SearchCommandFilterCount } from "~/components/SearchCommand/SearchCommandFilterCount";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
export const SearchCommandInput = /*#__PURE__*/ memo((param)=>{
    let { className, count, defaultValue, onValueChange, placeholder, value } = param;
    const { ui2 } = useTemporaryFeatureFlags();
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("relative -m-px flex h-10 shrink-0 gap-1 overflow-hidden rounded-t-4 border border-transparent", className),
        "data-testid": "SEARCH_COMMAND_INPUT",
        children: [
            /*#__PURE__*/ _jsx(SearchIcon, {
                className: "absolute left-3 top-1/2 size-4 -translate-y-1/2 text-grey-9"
            }),
            /*#__PURE__*/ _jsx(Command.Input, {
                className: classNames(ui2 ? "rounded-8" : "", "size-full pl-9 text-16 font-medium text-grey-12 outline-none placeholder:text-grey-9", className),
                "data-testid": "SEARCH_COMMAND_INPUT_INPUT",
                defaultValue: defaultValue,
                onValueChange: onValueChange,
                placeholder: placeholder,
                value: value
            }),
            !!count && /*#__PURE__*/ _jsx(SearchCommandFilterCount, {
                count: count
            })
        ]
    });
});
SearchCommandInput.displayName = "SearchCommandInput";
